import TextButton from '../TextButton'
import Text from '../../Text'
import TrashCanClosed from '../../Icons/svg/trashCanClosed.svg'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

const StyledDeleteButton = styled(TextButton)({
  '&&.MuiButton-root': {
    display: 'flex',
    flexDirection: 'row',
    '&.MuiButton-contained.Mui-disabled': {
      backgroundColor: 'gray',
      borderColor: 'gray'
    }
  }
})

const DeleteButtonGroupDetails = ({ className, text, onClick, disabled }) => {
  if (disabled) { return null }

  return (
    <StyledDeleteButton
      className={className}
      clickHandler={onClick}
      disabled={disabled}
    >
      <Box
        component='img'
        src={TrashCanClosed} 
        alt='deleteButton'
        sx={{ height: '15px', marginRight: '8px', width: '11px' }}
      />
      <Text type='h3' style={{ color: 'white' }}>{text}</Text>
    </StyledDeleteButton>
  )
}

export default DeleteButtonGroupDetails
